// extracted by mini-css-extract-plugin
export default {"robotWrapper":"Robot_robotWrapper__l6Pqa"};